// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {AccountGrantModel} from '@supermove/models';

// App
import WarningModal from '@shared/design/components/Modal/SmallModal/WarningModal';

const DeleteAccountGrantWarningModal = ({
  isOpen,
  handleClose,
  handleDelete,
  accountGrant,
  hasOtherPrimaryAccount,
}: {
  isOpen: boolean;
  handleClose: () => void;
  handleDelete: () => void;
  accountGrant: AccountGrantModel;
  hasOtherPrimaryAccount: boolean;
}) => {
  const willSendFromPrimary = !accountGrant.isPrimary && hasOtherPrimaryAccount;
  const warningText = `This will unlink ${accountGrant.identifier} and remove access to this email address, all emails will be sent from ${willSendFromPrimary ? 'the primary account' : 'Supermove'}.`;

  return (
    <WarningModal
      isOpen={isOpen}
      title={'Disconnect account'}
      message={warningText}
      handlePressOutside={handleClose}
      primaryActionText={'Disconnect'}
      handlePrimaryAction={handleDelete}
      secondaryActionText={'Cancel'}
      handleSecondaryAction={handleClose}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
DeleteAccountGrantWarningModal.fragment = gql`
  fragment DeleteAccountGrantWarningModal on AccountGrant {
    id
    identifier
    isPrimary
  }
`;

export default DeleteAccountGrantWarningModal;
